import {
  BadgeHelp,
  BookOpen,
  Bug,
  Building2,
  Calendar,
  Code,
  CreditCard,
  Database,
  FileText,
  Folder,
  Gift,
  Globe,
  GraduationCap,
  Headphones,
  Heart,
  Key,
  Laptop,
  Lightbulb,
  Lock,
  Mail,
  MessageCircle,
  Package,
  Plug,
  Rocket,
  Settings,
  Shield,
  ShoppingCart,
  Smartphone,
  Star,
  Truck,
  Users,
  Wrench,
  type LucideIcon,
} from "lucide-react";

/**
 * Icons a knowledge base collection can show on the portal (CollectionIcon renders them). The backend stores the lucide name ("book-open"); this
 * curated map keeps the bundle small (importing lucide's whole icon set would pull in every icon). An unknown or
 * missing name falls back to a folder.
 */
export const COLLECTION_ICONS: Record<string, { icon: LucideIcon; label: string }> = {
  "book-open": { icon: BookOpen, label: "Book" },
  rocket: { icon: Rocket, label: "Rocket" },
  "credit-card": { icon: CreditCard, label: "Billing" },
  wrench: { icon: Wrench, label: "Wrench" },
  settings: { icon: Settings, label: "Settings" },
  code: { icon: Code, label: "Code" },
  plug: { icon: Plug, label: "Integrations" },
  shield: { icon: Shield, label: "Shield" },
  lock: { icon: Lock, label: "Lock" },
  key: { icon: Key, label: "Key" },
  users: { icon: Users, label: "People" },
  smartphone: { icon: Smartphone, label: "Mobile" },
  laptop: { icon: Laptop, label: "Laptop" },
  globe: { icon: Globe, label: "Globe" },
  mail: { icon: Mail, label: "Email" },
  "message-circle": { icon: MessageCircle, label: "Chat" },
  headphones: { icon: Headphones, label: "Support" },
  "badge-help": { icon: BadgeHelp, label: "Help" },
  lightbulb: { icon: Lightbulb, label: "Tips" },
  "graduation-cap": { icon: GraduationCap, label: "Learning" },
  "file-text": { icon: FileText, label: "Document" },
  database: { icon: Database, label: "Data" },
  bug: { icon: Bug, label: "Bug" },
  "shopping-cart": { icon: ShoppingCart, label: "Shop" },
  package: { icon: Package, label: "Package" },
  truck: { icon: Truck, label: "Shipping" },
  calendar: { icon: Calendar, label: "Calendar" },
  "building-2": { icon: Building2, label: "Company" },
  gift: { icon: Gift, label: "Gift" },
  star: { icon: Star, label: "Star" },
  heart: { icon: Heart, label: "Heart" },
  folder: { icon: Folder, label: "Folder" },
};

